<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 操作 -->
    <el-row style="margin: 10px 0 10px 0;float: right;">
      <el-button @click="deleteLogs" size="small" type="danger" icon="el-icon-delete">删 除</el-button>
    </el-row>
    <!--列表-->
    <el-table ref="multipleTable" @selection-change="handleSelectionChange" size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>
      <el-table-column align="center" prop="optname" label="用 户" width="80" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="content" label="操 作" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="ip" label="IP" width="210" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="add_time" label="操作时间" width="140" show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
  import Pagination from '../../components/Pagination'
  import { logList,delLog } from '../../api/baseset'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        formInline: {
          page: 1,
          limit: 10
        },
        listData: [], //订单数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        multipleSelection: [],
        ids: ''
      }
    },
    components:{
      Pagination
    },
    created() {
      this.getdata(this.formInline)
    },
    methods:{
      getdata(param){
        this.loading = true
        logList(param).then(res => {
          this.loading = false
          if(res.code == 0){
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        }).catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
      },
      deleteLogs(){
        this.$confirm('您确定要删除此信息吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.loading = true
          let data = {ids:this.ids}
          delLog(data).then(res => {
            this.loading = false
            if(res.code == 0){
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: res.msg
              })
            }else{
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      handleSelectionChange(arr) {
        this.multipleSelection = arr;
        let str = '';
        arr.forEach(function(v){
          str += v.id+','
        })
        this.ids = str.substr(0,str.length-1);
      }
    }

  }
</script>

<style>
  .user-search {
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/system/log.vue